define('modules/ad_form/ad_form_view',[
  'backbone',
  'jquery',
  '_',
  'session',

  'URIjs/URI',
  'pikaday',

  './ad_form_model',

  'modules/form/CreateField',
  'modules/form/convert-form-data',
  'modules/htmlad/form/ean_code_form/htmlad_form_ean_code_form_view',

  'modules/htmlad/form/htmlad_form_model',
  'modules/htmlad/player/htmlad_player_view',

  'modules/loading/loading_spinner_view',

  'text!./ad_form_template.html',
  'text!modules/form/form_section_template.html',
], function (
  Backbone,
  $,
  _,
  session,
  URI,
  Pikaday,
  AdFormModel,
  CreateField,
  convertFormData,
  EanCodeFormView,
  HtmlAdModel,
  HtmlAdPlayer,
  Loading,
  ad_form_template,
  ad_form_section_template
) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      if (window.screen.width < 1920) {
        _.bindAll(this, 'detect_scroll');
        $(window).scroll(this.detect_scroll);
        this.prevScrollpos = window.pageYOffset;
      }

      this.formModel = new AdFormModel({
        id: this.ad_id || null,
        template_id: this.template_id || null,
        zone_id: this.zone_id || null,
        location_id: session.get('location_id'),
        is_campaign: this.is_campaign,
        player_id: this.player_id || null,
      });

      var _this = this;

      this.previewModel = new HtmlAdModel();

      this.dataBookingModel = new Backbone.Model();
      this.dataHtmladCollection = new Backbone.Collection();

      this.listenTo(
        this.formModel,
        'change',
        function (model) {
          if (model.get('id') != this.ad_id && model.get('newUrl')) {
            // We are "redirecting" the users to the edit page of the copied booking/htmlad
            // To accomodate store made zone changes to a central offer, we had to make a copy of the booking.
            // By making a booking, the id of changes.

            Backbone.trigger('navigate', model.get('newUrl'));
            this.formModel.set('id', model.get('id'));
            this.formModel.fetch();
            this.onAdModelSync(model);
          }

          this.stopListening(this.dataHtmladCollection, 'change');
          this.stopListening(this.dataBookingModel, 'change');
          this.stopListening(this.previewModel);

          if (model.get('id') && !model.get('is_campaign')) {
            this.formModel.trigger('enable_copy_button');
          }

          var htmlAdModel = model.get('htmladModel');
          var bookingModel = model.get('bookingModel');

          if (htmlAdModel.get('hasMultipleSections')) {
            this.hasMultipleSections = true;
          }

          htmlAdModel.get('sections').each(function (section) {
            if (
              !_this.dataHtmladCollection.findWhere({
                html_ad_section_id: section.get('html_ad_section_id'),
              })
            ) {
              _this.dataHtmladCollection.add(
                new Backbone.Model({
                  html_ad_section_id: section.get('html_ad_section_id'),
                  html_template_section_name: section.get(
                    'html_template_section_name'
                  ),
                })
              );
            }

            // Set title
            section.set('title', _this.getTitle(section));
            // Set removable
            var sectionsWithName = htmlAdModel.get('sections').where({
              html_template_section_name: section.get(
                'html_template_section_name'
              ),
            });
            var isRemovable = sectionsWithName.length > 1;
            var x = sectionsWithName.length < section.get('max_copies');
            var y =
              sectionsWithName[sectionsWithName.length - 1].get(
                'html_ad_section_id'
              ) === section.get('html_ad_section_id');
            var showAddButton = x && y;
            section.set('removable', isRemovable);
            section.set('show_add_button', showAddButton);

            // EAN
            var ean = htmlAdModel.get('ean') || section.get('ean');

            if (ean && ean.show_module) {
              var localContent = ean.get_local_content;
              var localPrice = ean.get_local_price;
              var eanCode = ean.ean_code;

              section.set(
                'eanCodeFormView',
                new EanCodeFormView({
                  content: localContent,
                  price: localPrice,
                  ean_code: eanCode,
                })
              );

              if (_this.hasMultipleSections) {
                _this.dataHtmladCollection
                  .findWhere({
                    html_ad_section_id: section.get('html_ad_section_id'),
                  })
                  .set({
                    get_local_content: localContent,
                    get_local_price: localPrice,
                    ean_code: eanCode,
                    populate: false,
                  });
              } else {
                _this.dataHtmladCollection
                  .findWhere({
                    html_ad_section_id: section.get('html_ad_section_id'),
                  })
                  .set({
                    get_local_content: localContent,
                    get_local_price: localPrice,
                    ean_code: eanCode,
                  });
              }

              section.get('eanCodeFormView').listenTo(
                section.get('eanCodeFormView').model,
                'change',
                function (model) {
                  _this.dataHtmladCollection
                    .findWhere({
                      html_ad_section_id: section.get('html_ad_section_id'),
                    })
                    .set({
                      get_local_content: model.get('content'),
                      get_local_price: model.get('price'),
                      ean_code: model.get('ean_code').trim(),
                      form_cleared: model.get('form_cleared'),
                      populate: true,
                    });
                  _this.eanIsInUse = true;
                  _this.actionSaveButton = false;
                  _this.sendForm();
                },
                this
              );

              section.get('eanCodeFormView').listenTo(
                section.get('eanCodeFormView').model,
                'set-local-content-unchecked',
                function () {
                  _this.dataHtmladCollection
                    .findWhere({
                      html_ad_section_id: section.get('html_ad_section_id'),
                    })
                    .set({
                      get_local_content: false,
                    });
                },
                this
              );

              section.get('eanCodeFormView').listenTo(
                section.get('eanCodeFormView').model,
                'set-local-price-unchecked',
                function () {
                  _this.dataHtmladCollection
                    .findWhere({
                      html_ad_section_id: section.get('html_ad_section_id'),
                    })
                    .set({
                      get_local_price: false,
                    });
                },
                this
              );
            }
          });

          // Remove models no longer needed
          var newDataHtmladCollection = new Backbone.Collection();
          this.dataHtmladCollection.each(function (model) {
            if (
              htmlAdModel.get('sections').findWhere({
                html_ad_section_id: model.get('html_ad_section_id'),
              })
            ) {
              newDataHtmladCollection.add(model);
            }
          });
          this.dataHtmladCollection.set(newDataHtmladCollection.toJSON());

          this.render();

          this.renderSections(
            htmlAdModel,
            this.dataHtmladCollection,
            '.js-form'
          );
          this.renderSections(
            bookingModel,
            this.dataBookingModel,
            '.js-form-schedule'
          );
          if (model.get('id')) {
            this.$('#select-save').val(bookingModel.get('status'));
          }

          Backbone.trigger('render:form');
          Backbone.trigger('render:form:ad_form');

          this.adModel = new AdFormModel({ id: model.get('id') });

          this.listenTo(
            this.dataHtmladCollection,
            'change',
            function (model) {
              this.formDirty = true;
              Backbone.trigger('formDirty', true);
            },
            this
          );

          this.listenTo(
            this.dataBookingModel,
            'change',
            function (model) {
              this.formDirty = true;
              Backbone.trigger('formDirty', true);
            },
            this
          );

          this.listenTo(
            this.previewModel,
            'sync',
            function (model) {
              this.previewMode(model.get('preview_url'));
              model.clear();
            },
            this
          );

          this.listenTo(
            this.adModel,
            'sync',
            function (model) {
              this.onAdModelSync(model);
            },
            this
          );
        },
        this
      );

      this.formModel.fetch();
    },

    subViews: [],
    actionSaveButton: false,
    eanIsInUse: false,
    hasMultipleSections: false,
    prevScrollpos: null,

    pickers: [],

    template: _.template(ad_form_template),
    section_template: _.template(ad_form_section_template),
    events: {
      'click .js-preview-ad': 'previewButtonHandler',
      'click .js-save': 'resetSaveSelect',
      'change .js-save': 'submitAdForm',
      'click .js-add-section': 'addSection',
      'click .js-remove-section': 'removeSection',
      'click .js-toggle-section': 'toggleSection',
    },

    onAdModelSync: function (model) {
      var htmlAdModel = model.get('htmladModel');
      var bookingModel = model.get('bookingModel');

      if (!htmlAdModel.get('error') && !bookingModel.get('error')) {
        Backbone.trigger('formDirty', false);
      }

      this.removeSections();
      this.renderSections(htmlAdModel, this.dataHtmladCollection, '.js-form');
      this.renderSections(
        bookingModel,
        this.dataBookingModel,
        '.js-form-schedule'
      );

      if (this.loading) {
        this.loading.done();
      }

      if (this.actionSaveButton) {
        this.showFormFeedback(htmlAdModel, bookingModel);
      }

      this.formModel.set(model.toJSON());
    },

    showOrHideMediaFactConnectionInfo: function () {
      var formModel = this.formModel.toJSON();
      if (formModel.htmlad) {
        if (!formModel.htmlad.ean.show_module) {
          $('#mediaFactConnectionInfotext').hide();
          $('#mediaFactConnectionInfotextIconChevronUp').hide();
          $('#mediaFactConnectionInfotextIconChevronDown').hide();
        }
      } else if (formModel.htmlad_multiple_sections) {
        var sectionHasEan = false;
        for (
          var i = 0;
          i < formModel.htmlad_multiple_sections.sections.length;
          i++
        ) {
          var section = formModel.htmlad_multiple_sections.sections[i];
          if (section.ean && section.ean.show_module) {
            sectionHasEan = true;
          }
        }
        if (!sectionHasEan) {
          $('#mediaFactConnectionInfotext').hide();
          $('#mediaFactConnectionInfotextIconChevronUp').hide();
          $('#mediaFactConnectionInfotextIconChevronDown').hide();
        }
      }
    },

    render: function () {
      this.$el.html(this.template(this.formModel.toJSON()));
      $('.js-button-form').trigger('click');

      this.showOrHideMediaFactConnectionInfo();

      return this;
    },

    removeSections: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.subViews = [];
    },

    renderSections: function (model, dataModel, target) {
      var self = this,
        $sections_html = $('<div />');

      var Field = CreateField.extend();

      model.get('sections').each(function (section, index) {
        var section_html = this.section_template(section.toJSON()),
          $section_html = $(section_html);

        var fields_html = [];

        var sectionDataModel;

        if (dataModel instanceof Backbone.Collection) {
          sectionDataModel = dataModel.at(index);
        } else {
          sectionDataModel = dataModel;
        }

        if (section.get('eanCodeFormView')) {
          $section_html
            .find('.js-form-section-content')
            .html(section.get('eanCodeFormView').$el);
        }

        section.get('fields').each(function (field) {
          var field_view = new Field({
            model: field,
            dataModel: sectionDataModel,
          });
          this.subViews.push(field_view);
          fields_html.push(field_view.$el);
        }, this);

        $section_html.find('.js-form-section-content').append(fields_html);
        if (section.get('collapsed')) {
          $section_html.find('.js-toggle-section')[0].classList.toggle('flip');
          $section_html.find('.js-form-section-content > .form-item').hide();
        }

        $sections_html.append($section_html);
      }, this);

      this.$(target).html($sections_html);

      this.addDatePickers();

      return this;
    },

    previewButtonHandler: function (e) {
      e.preventDefault();
      if (this.formDirty || !this.formModel.has('id')) {
        // form is dirty or has no id, need to POST to server
        if (this.hasMultipleSections) {
          if (this.formModel.get('htmlad_multiple_sections').id) {
            this.previewModel.set(
              'id',
              this.formModel.get('htmlad_multiple_sections').id
            );
          }
          var dataHtmladCollectionJSON = this.dataHtmladCollection.toJSON();
          dataHtmladCollectionJSON.forEach(function (model) {
            if (
              typeof model.html_ad_section_id === 'string' &&
              model.html_ad_section_id.startsWith('temp_')
            ) {
              delete model.html_ad_section_id;
            }
            for (var key in model) {
              if (model.hasOwnProperty(key)) {
                if (
                  typeof model[key] !== 'string' &&
                  model[key] !== null &&
                  model[key] !== undefined
                ) {
                  model[key] = JSON.stringify(model[key]);
                }
              }
            }
          });
          this.previewModel.set(
            'htmlad_multiple_sections',
            dataHtmladCollectionJSON
          );
        } else {
          var htmlAdJSON = this.dataHtmladCollection.at(0).toJSON();
          for (var key in htmlAdJSON) {
            if (htmlAdJSON.hasOwnProperty(key)) {
              if (
                typeof htmlAdJSON[key] !== 'string' &&
                htmlAdJSON[key] !== null &&
                htmlAdJSON[key] !== undefined
              ) {
                htmlAdJSON[key] = JSON.stringify(htmlAdJSON[key]);
              }
            }
          }
          if (this.formModel.get('htmlad').id) {
            this.previewModel.set('id', this.formModel.get('htmlad').id);
          }
          this.previewModel.set(htmlAdJSON);
        }

        this.previewModel.set('_preview', true);

        if (this.template_id) {
          this.previewModel.set('params', { template_id: this.template_id });
        }

        this.previewModel.save();
      } else {
        // form is pristine, the preview url should be safe to load
        this.previewMode();
      }
    },

    previewMode: function (url) {
      var self = this,
        htmlAdModel = this.formModel.get('htmladModel');
      var previewModel = new Backbone.Model({
        name: htmlAdModel.get('title'),
        preview: url || htmlAdModel.get('preview_url'),
        metadata: {
          orientations: htmlAdModel.get('orientations'),
        },
      });
      var htmlAdPlayer = new HtmlAdPlayer({
        model: previewModel,
        fitHeight: 600,
        close: function () {
          this.remove();
          self.editMode();
        },
      });
      this.$('.js-preview-iframe')
        .html(htmlAdPlayer.$el)
        .addClass('ad-preview');
      window.scrollTo(0, 0);

      //toggle buttons
      this.$('.js-preview-htmlad').addClass('is-hidden');
      this.$('.js-edit-htmlad').removeClass('is-hidden');

      // toggle form
      this.$('.js-form-content').addClass('is-hidden');
      // and buttons
      this.$('.form-buttons').addClass('is-hidden');
    },

    editMode: function () {
      this.$('.js-preview-iframe').removeClass('ad-preview').empty();
      this.$('.js-form-content').removeClass('is-hidden');
      this.$('.form-buttons').removeClass('is-hidden');
      this.$('.js-edit-htmlad').addClass('is-hidden');
      this.$('.js-preview-htmlad').removeClass('is-hidden');
    },

    switchView: function (view) {
      switch (view) {
        case 'form':
          this.$('.js-form-schedule').hide();
          this.$('.js-ean-code').show();
          this.$('.js-form').show();
          break;
        case 'schedule':
          this.$('.js-form').hide();
          this.$('.js-ean-code').hide();
          this.$('.js-form-schedule').show();
          break;
      }
    },

    addDatePickers: function () {
      // Remove old pickers
      _.each(
        this.pickers,
        function (picker) {
          picker.destroy();
        },
        this
      );
      var view = this;
      this.$('.js-form .date-input').each(function () {
        var field = this,
          picker = new Pikaday({
            field: field,
            firstDay: 1,
            showWeekNumber: true,
            format: _.t('date_format_fi'),
            setDefaultDate: true,
            i18n: session.get('lang').phrases.pikaday,
          });
        view.pickers.push(picker);
      }, this);
      this.$('.js-form-schedule .date-input').each(function () {
        var field = this,
          picker = new Pikaday({
            field: field,
            firstDay: 1,
            showWeekNumber: true,
            format: _.t('date_format'),
            setDefaultDate: true,
            i18n: session.get('lang').phrases.pikaday,
          });
        view.pickers.push(picker);
      }, this);
    },

    addSection: function (e) {
      e.preventDefault();
      var id = e.currentTarget.getAttribute('data-id');
      var htmladModel = this.formModel.get('htmladModel');
      var sectionCollection = htmladModel.get('sections');
      var newSection = sectionCollection
        .find(function (model) {
          return model.get('html_ad_section_id').toString() === id;
        })
        .clone();
      newSection.set('html_ad_section_id', _.uniqueId('temp_'));
      newSection.set('collapsed', false);
      var nFields = new Backbone.Collection();
      newSection.get('fields').each(function (field) {
        var nField = new Backbone.Model(field.attributes);
        nField.set('value', '');
        if (nField.get('options')) {
          var options = [];
          nField.get('options').forEach(function (option) {
            option.state = 'enabled';
            options.push(JSON.parse(JSON.stringify(option)));
          });
          nField.set('options', options);
        }
        if (nField.get('type') === 'media') {
          nField.set({
            file_id: 0,
            media_type: null,
            file_url: null,
          });
        }
        if (nField.get('type') === 'select') {
          nField.set('value', nField.get('options')[0].value);
          nField.get('options')[0].state = 'active';
        }
        nFields.add(nField);
      });
      newSection.set('fields', nFields);
      if (newSection.get('ean')) {
        var ean = JSON.parse(JSON.stringify(newSection.get('ean')));
        ean.ean_code = null;
        ean.get_local_content = false;
        ean.get_local_price = false;
        ean.populate = false;
        newSection.set('ean', ean);
      }
      sectionCollection = this.updateSections(sectionCollection);
      sectionCollection.add(newSection);
      this.formModel.set('htmladModel', htmladModel);
      this.formModel.trigger('change', this.formModel);
      this.formDirty = true;
      Backbone.trigger('formDirty', true);
    },

    removeSection: function (e) {
      e.preventDefault();
      var id = e.currentTarget.getAttribute('data-id');
      var htmladModel = this.formModel.get('htmladModel');
      var sectionCollection = htmladModel.get('sections');
      sectionCollection = this.updateSections(sectionCollection);
      sectionCollection.remove(
        sectionCollection.find(function (model) {
          return model.get('html_ad_section_id').toString() === id;
        })
      );
      this.formModel.trigger('change', this.formModel);
      this.formDirty = true;
      Backbone.trigger('formDirty', true);
    },

    toggleSection: function (e) {
      e.preventDefault();
      var id = e.currentTarget.getAttribute('data-id');
      var htmladModel = this.formModel.get('htmladModel');
      var sectionCollection = htmladModel.get('sections');
      var section = sectionCollection.find(function (model) {
        return model.get('html_ad_section_id').toString() === id;
      });
      section.set('collapsed', !section.get('collapsed'));
      e.currentTarget.classList.toggle('flip');
      var selector =
        '.form-section--' + id + ' .js-form-section-content > .form-item';
      this.$(selector).toggle();
    },

    getTitle: function (section) {
      var isTitleField = section.get('fields').findWhere({ is_title: true });
      if (isTitleField) {
        var value =
          isTitleField.get('value') || _.t('form_section.title.empty');
        value = value.split('<br>')[0];
        var title = isTitleField.get('label') + ' - ' + value;
        return title;
      }
      return '';
    },

    updateSections: function (sectionCollection) {
      var _this = this;
      sectionCollection.each(function (model) {
        var data = _this.dataHtmladCollection.findWhere({
          html_ad_section_id: model.get('html_ad_section_id'),
        });
        var fields = model.get('fields');
        fields.each(function (field) {
          var value = data.get(field.get('name'));
          if (field.get('type') === 'media') {
            value = field.get('file_url');
          }
          if (field.get('options')) {
            var options = [];
            field.get('options').forEach(function (option) {
              if (option.value === value) {
                option.state = 'active';
              } else if (value && value.includes(option.value)) {
                option.state = 'active';
              } else {
                option.state = 'enabled';
              }
              options.push(JSON.parse(JSON.stringify(option)));
            });
            field.set('options', options);
          }
          field.set('value', value);
        });
      });
      return sectionCollection;
    },

    submitAdForm: function (e) {
      e.preventDefault();
      var status = this.$('.js-save option:selected').val();
      this.actionSaveButton = true;

      this.adModel.clear().set('id', this.formModel.get('id'));
      this.adModel.set('zone_id', this.zone_id || null);
      this.adModel.set('is_campaign', this.is_campaign || false);
      if (status) {
        this.dataBookingModel.set('status', parseInt(status));
      }
      this.dataHtmladCollection.each(function (model) {
        model.set('populate', false);
      });
      this.sendForm();
    },

    resetSaveSelect: function (e) {
      e.preventDefault();
      this.$('.js-save').val('');
    },

    sendForm: function () {
      this.loading = new Loading();
      this.loading.start();
      this.adModel.set('template_id', this.template_id || null);
      if (this.hasMultipleSections) {
        var dataHtmladCollectionJSON = this.dataHtmladCollection.toJSON();
        dataHtmladCollectionJSON.forEach(function (model) {
          if (
            typeof model.html_ad_section_id === 'string' &&
            model.html_ad_section_id.startsWith('temp_')
          ) {
            delete model.html_ad_section_id;
          }
          for (var key in model) {
            if (model.hasOwnProperty(key)) {
              if (
                typeof model[key] !== 'string' &&
                model[key] !== null &&
                model[key] !== undefined
              ) {
                model[key] = JSON.stringify(model[key]);
              }
            }
          }
        });
        this.adModel.set('htmlad_multiple_sections', dataHtmladCollectionJSON);
      } else {
        var htmlAdJSON = this.dataHtmladCollection.at(0).toJSON();
        for (var key in htmlAdJSON) {
          if (htmlAdJSON.hasOwnProperty(key)) {
            if (
              typeof htmlAdJSON[key] !== 'string' &&
              htmlAdJSON[key] !== null &&
              htmlAdJSON[key] !== undefined
            ) {
              htmlAdJSON[key] = JSON.stringify(htmlAdJSON[key]);
            }
          }
        }
        this.adModel.set('htmlad', htmlAdJSON);
      }
      this.adModel.set('booking', this.dataBookingModel.toJSON());
      this.adModel.save(null, {
        error: function () {
          this.loading.done();
        }.bind(this),
      });
    },

    showFormFeedback: function (htmlAdModel, bookingModel) {
      if (htmlAdModel.get('error')) {
        $('.js-button-form').addClass('button--error');
      } else {
        $('.js-button-form').removeClass('button--error');
      }

      if (bookingModel.get('error')) {
        $('.js-button-schedule').addClass('button--error');
      } else {
        $('.js-button-schedule').removeClass('button--error');
      }

      $('.js-feedback').empty();

      if (htmlAdModel.get('error')) {
        $('.js-feedback').append(
          '<div class="ad-form-feedback ad-form-feedback--error"><span class="icon-status-error"></span> ' +
            htmlAdModel.get('error_message') +
            '</div>'
        );
      }

      if (bookingModel.get('error')) {
        $('.js-feedback').append(
          '<div class="ad-form-feedback ad-form-feedback--error"><span class="icon-status-error"></span> ' +
            bookingModel.get('error_message') +
            '</div>'
        );
      }

      if (!htmlAdModel.get('error') && !bookingModel.get('error')) {
        $('.js-feedback').html(
          '<div class="ad-form-feedback ad-form-feedback--ok"><span class="icon-status-success"></span> ' +
            _.t('htmladform.feedback.htmlad_saved') +
            '</div>'
        );
      }
      window.scrollTo(0, 0);
    },

    detect_scroll: function () {
      window.onscroll = function () {
        var currentScrollPos = window.pageYOffset;
        if (this.prevScrollpos > currentScrollPos && currentScrollPos !== 0) {
          this.$('.ad-form-footer').hide();
        } else {
          this.$('.ad-form-footer').show();
        }
        this.prevScrollpos = currentScrollPos;
      };
    },

    remove: function () {
      _.each(
        this.pickers,
        function (picker) {
          picker.destroy();
        },
        this
      );

      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});

